import {MESSAGES, SUPERUSER_PERMISSION_ID} from "../../constants";
import Button from "../../components/common/button";
import SendPasswordLink from "../manageUserProfile/sendPasswordLink";
import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {
  clearEditDistrictAlert,
  clearEditDistrictErrors,
  restoreCurrentDistrictFromLocalStorage
} from "../../actions/districts";
import Alert from "../../components/common/alert";
import {useNavigate} from "react-router-dom";

const DistrictInfo = (props) => {
  const {
    editDistrictAlert
  } = props;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const district = useSelector((state) => state.districts.currentDistrict);

  useEffect(() => {
    if (!district) {
      dispatch(restoreCurrentDistrictFromLocalStorage())
    }
  }, [dispatch, district]);

  const gotoEditAction = () => {
    dispatch(clearEditDistrictAlert());
    dispatch(clearEditDistrictErrors());
    navigate('/edit-district');
  }

  return (
    <>
      <div className='manage-schools-alerts'>
        {(editDistrictAlert) && <Alert messageType={'success'} onDismiss={() => dispatch(clearEditDistrictAlert())}>{editDistrictAlert}</Alert>}
      </div>
      <div className="district-info-container">
        <div className='district-info-header'>
          <div className='district-info-buttons'>
            <Button label='Edit' action={gotoEditAction}/>
          </div>
        </div>
        <div className="district-info-body">
          <div className="district-info">
            <div className="district-info-item">
              <div className="district-info-label">
                Name:
              </div>
              <div className="district-info-value">
                {district ? district.name : ''}
              </div>
            </div>
            <div className="district-info-item">
              <div className="district-info-label">
                External ID:
              </div>
              <div className="district-info-value">
                {district ? district.externalId : ''}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DistrictInfo;